import api from '../api'
import { axios as $http } from 'cm'
import { throttle } from '../../../../public-resource/libs/utils/index'
import Bridge from '../../../../frontend-lib/lib/Bridge'

let IS_APP = window.$platform.isYixinliApp
let myBridge = new Bridge()

class BranchList {
  constructor(token) {
    this.token = token
    this.loading = false
    this.activedTab = 0
    this.childTab = []
    this.allList = {}
    this.jointList = {}
    this.rankList = {}
    this.branchStatus = {
      cantonal_id: 0,
      cantonal_status: null
    }
    this.isCreateBranch = true

    this.navKey = ['all', 'joint', 'rank']
    this.navKey.forEach(key => {
      this[key + 'List'] = {
        activedTab: 0,
        page: [1],
        data: [[]],
        scrollTo: [0],
        nomore: [false],
        alreadyLoadIds: [[]]
      }
    })

    this.getListData()
    this.getBranchStatus()
    this.bindEvent()
  }
  currentNav() {
    return this.navKey[this.activedTab]
  }
  currentNavList() {
    return this[this.currentNav() + 'List']
  }
  activedChildTab() {
    return this.currentNavList().activedTab
  }
  nomore() {
    return this.currentNavList().nomore[this.activedChildTab()]
  }
  getBranchStatus() {
    let token = this.token
    if (!token) return
    let params = {
      token
    }
    $http
      .get(api.getBranchStatus, {
        params
      })
      .then(({ data: res }) => {
        if (+res.code === 0) {
          if (res.data.cantonal_status === undefined) {
            this.isCreateBranch = false
          } else {
            this.branchStatus = res.data

            let status = this.branchStatus.cantonal_status
            this.isCreateBranch = status !== null && status !== 2
          }
        } else {
          window.toast(res.message)
        }
      })
      .catch(err => {
        console.error(err)
      })
  }
  getListData(force = false) {
    if (this.isLoading && !force) return
    if (this.nomore()) return

    this.isLoading = true
    $('.loading-more').show()

    let currentNavList = this.currentNavList()
    let activedTab = currentNavList.activedTab
    let isMyJoinTab = this.activedTab === 1

    let notChildTab = this.childTab == false

    let params = {
      tab: this.currentNav(),
      tag_id: notChildTab ? '' : this.childTab[activedTab].id,
      scope: notChildTab ? '' : this.childTab[activedTab].scope,
      page: currentNavList.page[activedTab],
      token: this.token
    }

    $http
      .get(api.getBranchList, {
        params
      })
      .then(({ data: res }) => {
        this.isLoading = false
        $('.loading-more').hide()
        if (+res.code === 0) {
          let data = res.data

          let childTab = data.tags
          if (notChildTab && childTab.length) {
            this.childTab = childTab
            this.renderTag()
            this.generateListFromTag()
          }

          currentNavList.page[activedTab]++

          if (!data.list.length) {
            currentNavList.nomore[activedTab] = true
          }

          let myBranchId = this.branchStatus.cantonal_id
          if (
            isMyJoinTab &&
            !activedTab &&
            this.branchStatus.cantonal_status === 3 &&
            currentNavList.alreadyLoadIds[activedTab].indexOf(myBranchId) === -1
          ) {
            this.branchStatus.id = myBranchId
            currentNavList.alreadyLoadIds[activedTab].push(myBranchId)
            currentNavList.data[activedTab].push(this.branchStatus)
          }

          let uniqueList = data.list.filter(item => {
            if (
              currentNavList.alreadyLoadIds[activedTab].indexOf(item.id) === -1
            ) {
              currentNavList.alreadyLoadIds[activedTab].push(item.id)
              return item
            }
          })

          currentNavList.data[activedTab].push(...uniqueList)

          this.renderList()
          if (force) this.refreshScroll()
        } else {
          window.toast(res.message)
        }
      })
      .catch(() => {
        this.isLoading = false
        $('.loading-more').hide()
      })
  }
  generateListFromTag() {
    let page = [],
      data = [],
      scrollTo = [],
      nomore = [],
      alreadyLoadIds = []
    for (
      let index = 0, length = this.childTab.length;
      index < length;
      index++
    ) {
      page.push(1)
      data.push([])
      scrollTo.push(0)
      nomore.push(false)
      alreadyLoadIds.push([])
    }
    this.navKey.forEach(key => {
      this[key + 'List'].page = Object.assign([], page)
      this[key + 'List'].data = JSON.parse(JSON.stringify(data))
      this[key + 'List'].scrollTo = Object.assign([], scrollTo)
      this[key + 'List'].nomore = Object.assign([], nomore)
      this[key + 'List'].alreadyLoadIds = JSON.parse(
        JSON.stringify(alreadyLoadIds)
      )
    })
  }
  refreshScroll() {
    $('.branchsWrap .listwrap')[0].scrollTop = this.currentNavList().scrollTo[
      this.activedChildTab()
    ]
  }
  renderTag() {
    let childTab = ''
    this.childTab.forEach((item, index) => {
      if (index) {
        childTab += `<span>${item.name}</span>`
      } else {
        childTab += `<span class="active">${item.name}</span>`
      }
    })
    $('.branchsWrap .child-tab .wrap').html(childTab)
  }
  renderList() {
    let list = ''
    if (!this.isCreateBranch) {
      if (this.activedTab === 0) {
        list += '<div class="createMyBranch">创建分馆，聚集我的影响力</div>'
      }
      if (this.activedTab === 1) {
        list += '<div class="createMyBranch">创建我的分馆</div>'
      }
    }
    this.currentNavList().data[this.activedChildTab()].forEach(item => {
      list += `
        <li branchId="${item.id}">
          <img src="${item.cantonal_logo}" />
          <div class="info">
            <span class="info-title">
              ${item.cantonal_name}
              ${
                this.activedTab === 1 &&
                this.branchStatus.cantonal_id === item.id
                  ? '<span>我是馆长</span>'
                  : ''
              }
            </span>
            <span class="info-other">成员：${
              item.number_of_people
            }人&nbsp;&nbsp;&nbsp;&nbsp;互助分：${item.score}</span>
            ${
              item.latest_question.title
                ? `<span class="info-new">最新：${item.latest_question.title}</span>`
                : ''
            }
          </div>
        </li>
      `
    })
    $('.branchsWrap .branchlist').html(list)
  }
  afterChangeTab() {
    if (
      this.currentNavList().data[this.activedChildTab()].length ||
      this.nomore()
    ) {
      this.renderList()
      this.refreshScroll()
    } else {
      this.getListData(true)
    }
  }
  bindEvent() {
    let that = this

    $(document).delegate('.branchsWrap .navbar span', 'click', function() {
      let $this = $(this)
      if ($this.hasClass('active')) return

      let idx = $this.index()
      if (idx === 1 && !that.token) {
        window.toast('检测到暂未登录,即将跳转到登录页面~')
        setTimeout(() => {
          window.location.href = api.login
        }, 2000)
        return
      }

      $this
        .addClass('active')
        .siblings()
        .removeClass('active')

      that.currentNavList().scrollTo[that.activedChildTab()] = $(
        '.branchsWrap .listwrap'
      )[0].scrollTop
      that.activedTab = idx

      let tag = $('.branchsWrap .child-tab span')[that.activedChildTab()]
      if (tag) {
        $(tag)
          .addClass('active')
          .siblings()
          .removeClass('active')
        tag.scrollIntoView()
      }

      that.afterChangeTab()
    })

    $(document).delegate('.branchsWrap .child-tab span', 'click', function() {
      let $this = $(this)
      if ($this.hasClass('active')) return

      $this
        .addClass('active')
        .siblings()
        .removeClass('active')

      that.currentNavList().scrollTo[that.activedChildTab()] = $(
        '.branchsWrap .listwrap'
      )[0].scrollTop
      that.currentNavList().activedTab = $this.index()

      that.afterChangeTab()
    })

    $(document).delegate('.branchsWrap .branchlist li', 'click', function() {
      let url = `${api.host}/qa/cantonal/cantonal-index?cantonal_id=${$(
        this
      ).attr('branchId')}`
      if (IS_APP) {
        myBridge.call('openWebView', {
          url,
          isCurrentPageOpen: 0
        })
      } else {
        window.open(url)
      }
    })

    $(document).delegate(
      '.branchsWrap .branchlist .createMyBranch',
      'click',
      function() {
        let url = `${api.static}/msite/index.html#/qaBranchCreate?cantonalId=${that.branchStatus.cantonal_id}`
        if (IS_APP) {
          myBridge.call('openWebView', {
            url,
            isCurrentPageOpen: 0
          })
        } else {
          window.open(url)
        }
      }
    )

    let scroll = throttle(function() {
      // console.log($(this).innerHeight(), $(this).scrollTop(), this.scrollHeight)
      let height = $(this).innerHeight()
      let scrollHeight = this.scrollHeight
      let scrollTop = $(this).scrollTop()
      if (scrollTop > 0 && height + scrollTop > scrollHeight - 20) {
        that.getListData()
      }
    }, 500)
    $('.branchsWrap .listwrap').on('scroll', scroll)
  }
}

module.exports = BranchList



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/modules/branchList.js